export enum CatalogPartPopupInfoKind {
  Details = 0,
  Application = 1,
  SpecialTools = 2
}
